// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","titleContainer":"G701cda","title":"G1a7ce4","subTitle":"G80efa1"};